export const CUBE_ID = 'facts_slides';
export const REPORT_ID = 'ap-annual-production';
export const REPORT_APE_ID = 'ap-annual-production-ape';
export const SLIDE_NUMBER = 11;
